import { User } from '@prisma/client'
import { Form, Radio, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/executiveAssistant/common'
import { SelectProviderAccount } from '~/features/formConfiguration/client/components/CustomInputs/SelectProviderAccount'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepEmailProviders: React.FC<Props> = ({ user, ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          I'm almost ready to manage your inbox
        </TitlePrimary>

        <Typography.Text type="secondary" className="mb-10">
          I'll need access to your email inbox to start working. Don't worry I
          can't send emails directly
        </Typography.Text>

        <Form.Item name={['emailServices', 'provider']}>
          <Radio.Group
            block={true}
            optionType="button"
            buttonStyle="solid"
            options={[
              {
                label: 'Google',
                value: 'google',
              },
              {
                label: 'Outlook',
                value: 'outlook',
              },
              {
                label: 'IMAP',
                value: 'nylas',
              },
            ]}
          />
        </Form.Item>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {instance => {
            const provider = instance.getFieldValue([
              'emailServices',
              'provider',
            ])

            if (provider === 'outlook') {
              return (
                <CommonClient.Form.InputWrapper label="Add your Outlook Account">
                  <Form.Item
                    name={['emailServices', 'accountOutlookMail']}
                    rules={[
                      {
                        required: true,
                        message: 'Please connect your account to continue',
                      },
                    ]}
                  >
                    <SelectProviderAccount providerKey="outlookMail" />
                  </Form.Item>
                </CommonClient.Form.InputWrapper>
              )
            }

            if (provider === 'nylas') {
              return (
                <CommonClient.Form.InputWrapper label="Add your IMAP Account">
                  <Form.Item
                    name={['emailServices', 'accountNylas']}
                    rules={[
                      {
                        required: true,
                        message: 'Please connect your account to continue',
                      },
                    ]}
                  >
                    <SelectProviderAccount providerKey="nylas" />
                  </Form.Item>
                </CommonClient.Form.InputWrapper>
              )
            }

            return (
              <CommonClient.Form.InputWrapper label="Add your Gmail Account">
                <Form.Item
                  name={['emailServices', 'accountGmail']}
                  rules={[
                    {
                      required: true,
                      message: 'Please connect your account to continue',
                    },
                  ]}
                >
                  <SelectProviderAccount providerKey="gmail" />
                </Form.Item>
              </CommonClient.Form.InputWrapper>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
